import { api } from '@/api';

const getInvestorVerificationSettings = () => {
  return api.get('/api/kyc/v1/editingVerificationQuestionSection');
};

const updateVerificationSettings = ({ visibleTypeGroup, verificationQuestionSectionId }) => {
  return api.put('/api/kyc/v1/editingVerificationQuestionSection', {
    visibleTypeGroup,
    verificationQuestionSectionId
  });
};

const getSettings = () => {
  return api.get('/api/kyc/v1/project/schema?forSchema=SETTINGS');
};

const updateSettings = ({ id, text, type }) => {
  const formData = new FormData();
  formData.append('componentSchemaId', id);
  formData.append('text', text);
  formData.append('type', type);

  return api.put('/api/kyc/v1/admin/project/schema?forSchema=SETTINGS', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const SettingsApi = {
  getInvestorVerificationSettings,
  updateVerificationSettings,
  getSettings,
  updateSettings
};
